import { cn } from '@wundo/ui';

/*
 * Whatever else the message was carrying, verbatim. Only ever shown in debug.
 * On the user's own bubble the fill is the one drawn for the brand colour, or
 * a dump inside it would be a pale rectangle nobody can read.
 */
export function MetadataDump({
  children,
  onPrimary,
}: {
  children: string;
  onPrimary?: boolean;
}) {
  return (
    <pre
      className={cn(
        'mt-2 overflow-x-auto rounded-sm p-2 text-xs whitespace-pre-wrap',
        onPrimary ? 'bg-on-primary-fill' : 'bg-fill text-ink-body',
      )}
    >
      {children}
    </pre>
  );
}
